import type { Attachment } from "../../../domain/request-detail-types";

export function isPreviewableAttachment(attachment: Attachment) {
  return (
    attachment.content_type === "application/pdf" ||
    attachment.content_type.startsWith("image/")
  );
}

export function revisionValue(value: unknown) {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "object") {
    const name = "name" in value ? value.name : undefined;
    const version = "version" in value ? value.version : undefined;
    return name
      ? `${name}${version ? ` · Sürüm ${version}` : ""}`
      : "Belge";
  }
  return String(value);
}

export function dateTime(value: string | null) {
  if (!value) return "—";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return new Intl.DateTimeFormat("tr-TR", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(parsed);
}

export function dateOnly(value: string) {
  const [year, month, day] = value.slice(0, 10).split("-").map(Number);
  if (!year || !month || !day) return value;
  return new Intl.DateTimeFormat("tr-TR", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(year, month - 1, day)));
}

export function remainingDayLabel(value: string) {
  const [year, month, day] = value.slice(0, 10).split("-").map(Number);
  if (!year || !month || !day) return "";
  const now = new Date();
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const target = Date.UTC(year, month - 1, day);
  const remainingDays = Math.round((target - today) / 86_400_000);
  if (remainingDays === 0) return "bugün";
  if (remainingDays > 0) return `${remainingDays} gün kaldı`;
  return `${Math.abs(remainingDays)} gün geçti`;
}

export const historyActionLabels: Record<string, string> = {
  REQUEST_SUBMITTED: "Talep oluşturuldu",
  PURCHASE_REQUEST_SUBMITTED: "Talep Satın Alma’ya iletildi",
  DEMO_REQUEST_SUBMITTED: "Talep Satın Alma’ya iletildi",
  DEMO_REQUEST_REVISED_AND_RESUBMITTED: "Talep güncellenip yeniden iletildi",
  OFFER_CREATED: "Teklif kaydedildi",
  DEMO_OFFER_ADDED: "Teklif kaydedildi",
  DEMO_OFFER_COLLECTION_STARTED: "Teklif toplama başladı",
  OFFER_EVALUATION_CREATED: "Teklif değerlendirmesi yenilendi",
  DEMO_OFFER_EVALUATION_REFRESHED: "Teklif değerlendirmesi yenilendi",
  PROCUREMENT_RECOMMENDATION_SAVED: "Satın Alma kararı kaydedildi",
  ROUTED_FOR_APPROVAL: "Talep onaya gönderildi",
  DEMO_ROUTED_FOR_APPROVAL: "Talep onaya gönderildi",
  REVISION_REQUESTED: "Düzeltme istendi",
  DEMO_REVISION_REQUESTED: "Düzeltme istendi",
  APPROVED: "Talep onaylandı",
  DEMO_REQUEST_APPROVED: "Talep onaylandı",
  REJECTED: "Talep reddedildi",
  DEMO_REQUEST_REJECTED: "Talep reddedildi",
  COMMENT_ADDED: "Yorum eklendi",
  ATTACHMENT_UPLOADED: "Belge eklendi",
};

export function approvalRoleLabel(role: string) {
  const labels: Record<string, string> = {
    SATIN_ALMA: "Satın Alma Uzmanı",
    SATIN_ALMA_MUDURU: "Satın Alma Müdürü",
    GENEL_MUDUR: "Genel Müdür",
  };
  return labels[role] ?? role;
}

export function approvalStatusLabel(status: string) {
  switch (status) {
    case "PENDING":
      return "Onay bekliyor";
    case "QUEUED":
      return "Sırada";
    case "APPROVED":
      return "Onaylandı";
    case "REJECTED":
      return "Reddedildi";
    case "REVISION_REQUESTED":
      return "Düzeltme istendi";
    default:
      return status;
  }
}
